export const floatingStateTextList = {
  'tde': [
    {
      'check': false,
      'text': 'NO DISPONIBLE',
      'shortText': 'NO',
    },
    {
      'check': false,
      'text': 'DISPONIBLE ',
      'shortText': 'DISP.',
    },
    {
      'check': false,
      'text': 'RESERVADO',
      'shortText': 'RES.',
    },
    {
      'check': false,
      'text': 'SOL. NACIONALIZACIÓN',
      'shortText': 'SOL.',
    },
  ],
  'dealer': [
    {
      'check': false,
      'text': 'DISPONIBLE ',
      'shortText': 'DISP.',
    },
    {
      'check': false,
      'text': 'RESERVADO',
      'shortText': 'RES.',
    },
    {
      'check': false,
      'text': 'SOL. NACIONALIZACIÓN',
      'shortText': 'SOL.',
    },
  ],
};
